export default {
  keyCurrency: (state, getters, rootState) => rootState.definitions.account.account.currency_code,
  isProcessing: (state) => state.isPosting || state.isPatching || state.isDeleting || state.isMoving,
};
